export const IconLocationFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 25 24"
      {...props}
    >
      <mask
        id="IconLocationFilled_svg__a"
        width={25}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M.936 0h24v24h-24z" />
      </mask>
      <g mask="url(#IconLocationFilled_svg__a)">
        <path d="M12.936 21.325a2.1 2.1 0 0 1-.7-.125 1.8 1.8 0 0 1-.625-.375A39 39 0 0 1 8.736 17.9q-1.25-1.425-2.087-2.762-.837-1.338-1.275-2.575T4.936 10.2q0-3.75 2.413-5.975T12.936 2q3.176 0 5.588 2.225t2.412 5.975q0 1.125-.437 2.363-.438 1.237-1.275 2.574a21.7 21.7 0 0 1-2.088 2.763 39 39 0 0 1-2.875 2.925 1.8 1.8 0 0 1-.625.375 2.1 2.1 0 0 1-.7.125m0-9.325q.825 0 1.413-.588.587-.587.587-1.412t-.587-1.412A1.93 1.93 0 0 0 12.936 8q-.825 0-1.412.588A1.93 1.93 0 0 0 10.936 10q0 .825.588 1.412.588.588 1.412.588" />
      </g>
    </svg>
  );
};
